var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "App Icon/DriveFlex") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-Icon/DriveFlex",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core-Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    transform: "translate(-0.400000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.398674665,32.4296245 L16,32.4296245 L16,48 C7.61243659,47.5025867 0.896088004,40.8011306 0.398674665,32.4296245 Z",
    id: "Combined-Shape-Copy-5",
    fill: "#390315",
    transform: "translate(8.199337, 40.214812) scale(-1, -1) translate(-8.199337, -40.214812) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,29.9794949 L34,48 C15.636862,47.5809493 0.81726237,32.7722574 0.39821167,14.4091194 L18.4187167,14.4091194 C18.9161301,22.7806255 25.6284938,29.4820816 34,29.9794949 Z",
    id: "Combined-Shape-Copy-6",
    fill: "#59092B",
    transform: "translate(17.199106, 31.204560) scale(-1, -1) translate(-17.199106, -31.204560) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4,33.5973054 L48.4,48 C22.0836316,47.5770272 0.82206946,26.3227932 0.39909668,0.00642484915 L14.8017912,0.00642484915 C15.220842,18.3695628 30.036864,33.1782547 48.4,33.5973054 Z",
    id: "Combined-Shape-Copy-7",
    fill: "#670D36",
    transform: "translate(24.399548, 24.003212) scale(-1, -1) translate(-24.399548, -24.003212) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4,47.9935752 L0.4,48 L0.4,0 C0.408668141,0.531241828 0.4258225,1.06042081 0.45133341,1.58740723 C1.05492132,14.0559012 6.33646636,25.2970087 14.5785612,33.5926225 C23.2447701,42.3151043 35.1840503,47.7811603 48.4,47.9935752 Z",
    id: "Combined-Shape-Copy-8",
    fill: "#8D1D59",
    transform: "translate(24.400000, 24.000000) scale(-1, -1) translate(-24.400000, -24.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4,43.1777465 L11.1480434,32.4297031 L11.1480434,48 C6.95985048,47.7512932 3.18842564,45.9557014 0.4,43.1777465 Z",
    id: "Combined-Shape",
    fill: "#25010A",
    transform: "translate(5.774022, 40.214852) scale(-1, -1) translate(-5.774022, -40.214852) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4,27.1956612 L13.186501,14.4091602 C15.9726304,17.1917004 19.7421846,18.9905668 23.9263053,19.2396251 L23.9263053,37.2601957 C14.7463744,37.050238 6.45212227,33.2441514 0.4,27.1956612 Z",
    id: "Combined-Shape",
    fill: "#390315",
    transform: "translate(12.163153, 25.834678) scale(-1, -1) translate(-12.163153, -25.834678) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4,10.1887777 L10.5823383,0.00643937551 C16.6337997,6.05538658 24.9276804,9.86170806 34.1081911,10.0714465 L34.1081911,24.4741472 C20.9510653,24.2624386 9.05749392,18.8437517 0.4,10.1887777 Z",
    id: "Combined-Shape",
    fill: "#42031A",
    transform: "translate(17.254096, 12.240293) scale(-1, -1) translate(-17.254096, -12.240293) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4,14.2927875 L14.6927875,0 C23.349533,8.6557422 35.2420193,14.0748796 48.4,14.2863627 L0.4,14.2927875 Z",
    id: "Combined-Shape",
    fill: "#5B082B",
    transform: "translate(24.400000, 7.146394) scale(-1, -1) translate(-24.400000, -7.146394) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.7890625,39.8390625 L9.34296875,39.8390625 L8.67265625,42.4 L6,42.4 L9.91015625,29.8875 L12.221875,29.8875 L16.1578125,42.4 L13.459375,42.4 L12.7890625,39.8390625 Z M9.89296875,37.7335938 L12.2304687,37.7335938 L11.0617187,33.2734375 L9.89296875,37.7335938 Z M16.8796875,37.4671875 C16.8796875,35.9432215 17.1374974,34.8059933 17.653125,34.0554688 C18.1687526,33.3049442 18.9192659,32.9296875 19.9046875,32.9296875 C20.6208369,32.9296875 21.2166643,33.2390594 21.6921875,33.8578125 L21.6921875,29.2 L24.1414062,29.2 L24.1414062,42.4 L21.9328125,42.4 L21.8210937,41.4546875 C21.3226538,42.1994829 20.6809935,42.571875 19.8960937,42.571875 C18.9221305,42.571875 18.1787786,42.1994829 17.6660156,41.4546875 C17.1532526,40.7098921 16.8911459,39.6156322 16.8796875,38.171875 L16.8796875,37.4671875 Z M19.3203125,38.0773438 C19.3203125,38.994015 19.4177074,39.634243 19.6125,39.9980469 C19.8072926,40.3618508 20.1367164,40.54375 20.6007812,40.54375 C21.0820337,40.54375 21.4458321,40.3289084 21.6921875,39.8992188 L21.6921875,35.6539063 C21.4515613,35.1955706 21.0906274,34.9664063 20.609375,34.9664063 C20.1624978,34.9664063 19.8359385,35.1468732 19.6296875,35.5078125 C19.4234365,35.8687518 19.3203125,36.5104121 19.3203125,37.4328125 L19.3203125,38.0773438 Z M28.2148438,33.1015625 L28.2835937,33.9609375 C28.8278673,33.2734341 29.5468705,32.9296875 30.440625,32.9296875 C31.3687546,32.9296875 32.0247377,33.3479125 32.4085937,34.184375 C32.9414089,33.3479125 33.7005159,32.9296875 34.6859375,32.9296875 C36.313029,32.9296875 37.1466144,34.0554575 37.1867187,36.3070313 L37.1867187,42.4 L34.7546875,42.4 L34.7546875,36.4617188 C34.7546875,35.9231744 34.6802091,35.5393241 34.53125,35.3101563 C34.3822909,35.0809884 34.1302101,34.9664063 33.775,34.9664063 C33.3223936,34.9664063 32.9843761,35.2442681 32.7609375,35.8 L32.778125,36.0921875 L32.778125,42.4 L30.3460937,42.4 L30.3460937,36.4789063 C30.3460937,35.9460911 30.2744799,35.5608085 30.13125,35.3230469 C29.9880201,35.0852853 29.7330748,34.9664063 29.3664062,34.9664063 C28.948175,34.9664063 28.6158866,35.1927061 28.3695312,35.6453125 L28.3695312,42.4 L25.9375,42.4 L25.9375,33.1015625 L28.2148438,33.1015625 Z",
    id: "Adm",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Right-Bar",
    fill: "#82C600",
    x: 44,
    y: 0,
    width: 4,
    height: 48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.007e8ca41f6d16605b8c83980ddf6e99.svg";
export { ForwardRef as ReactComponent };